<div class="form-group">
  @if (showLabel && (labelText || question?.question_prompt || question?.email_version)) {
    <label>
      {{question?.question_prompt ? question?.question_prompt : question?.email_version ? question?.email_version : labelText}}
    </label>
  }
  <div class="row row--xxs">
    @for (item of items; track item) {
      <div class="col-6">
        <label class="custom-input custom-input--icon-lg">
          <input type="radio" [name]="uniqueControlName" (click)="checkRadio(item?.answer ? item?.answer : item)"
            [checked]="item?.answer === question?.answer || item?.answer === selectedValue || item === selectedValue">
            <span class="custom-input__label">
              @if (item?.image_url) {
                <img [src]="item?.image_url ? item?.image_url : ''" class="icon">
              }
              <h5 class="font-16">{{item?.answer ? item.answer : item}}</h5>
            </span>
          </label>
        </div>
      }
    </div>
  </div>